import {JsonCustomHook} from 'OK/JsonCustomHook';
import {BanDataCfgJs, IBanDataCfgData} from 'OK/BanDataCfgJs';

export default class BannerNavigationDataProviderHookJs extends JsonCustomHook<IBanDataCfgData> {
    constructor(uid: string, element: HTMLElement) {
        super("json_abp", element);
    }

    applyContent(json: IBanDataCfgData) {
        BanDataCfgJs.getInstance().setData(json);
    }
}